/**
 * Status-overlay copy while a WS `registration-status-update` is in flight
 * (before pendingPlaylistSwap / Feed / Listas refresh). Hard-coded PT like CurrentState.
 */

export type TRegistrationStatusRefreshOverlayLine = {
  label: string
  value: string
}

export function resolveRegistrationStatusRefreshOverlayLine(
  pending: boolean
): TRegistrationStatusRefreshOverlayLine | null {
  if (!pending) {
    return null
  }
  return {
    label: 'Atualiz.',
    value: 'Recebendo configuração…'
  }
}
